(function(angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name OrganizationService
     *
     * @description
     * Service used for obtaining tenant/organization-wide information
     */
    angular.module('GorillaBoy.services')
    .factory('OrganizationService', [
        '$rootScope',
        '$http',
        '$log',
        '$q',
        'authenticatedUser',
        'EndpointService',
        'AppConstants',
        'SourceConstant',
        OrganizationService
    ]);

    function OrganizationService($rootScope, $http, $log, $q, authenticatedUser, EndpointService, AppConstants, SourceConstant) {
        var orgService = {},
            lastSearchOrgUsers = [],

            // AppConstant bindings
            collaboratorTypes = AppConstants.CollaboratorTypes,
            httpMethods = AppConstants.HttpMethods;

        function SERVICE_ROOT() {
            return EndpointService.endpoint() + 'organization/';
        }

        function NEW_SERVICE_ROOT() {
            return EndpointService.endpoint(true) + 'organizations/';
        }

        orgService.ORG_USER_USERNAME = 'Everyone';

        orgService.getFeatureDetails = function(featureName) {
            var config = {
                url: EndpointService.endpoint(true) + 'adminfeature?featureId=' + encodeURIComponent(featureName) + '&includeConfig=false',
                method: httpMethods.GET
            };

            return $q(function(resolve, reject) {
                $http(EndpointService.tokenize(config)).then(function(response) {
                    if (!response) {
                        reject(response);
                        return;
                    }
                    var data = response.data;
                    if (!data.Feature) {
                        resolve({});
                        return;
                    }
                    resolve(data.Feature);
                }, function(response) {
                    reject(response);
                });
            });
        };

        orgService.toggleOrgFeature = function(featureName, enableFlag) {
            var config = {
                url: EndpointService.endpoint(true) + '/adminfeatures',
                method: httpMethods.POST,
                data : { "FeatureList" : [
                                            {
                                                "FeatureId" : featureName,
                                                "Enabled" : enableFlag
                                            }
                                        ]
                }
            };
            return $http(EndpointService.tokenize(config));
        };

        orgService.getOrganization = function() {
            var config = {
                url: SERVICE_ROOT(),
                method: httpMethods.GET
            };
            return $http(EndpointService.tokenize(config));
        };

        orgService.getOrganizationByAlias = function(alias) {
            var config = {
                url: NEW_SERVICE_ROOT() + 'alias/' + encodeURIComponent(alias),
                method: httpMethods.GET
            };
            return $http(EndpointService.tokenize(config));
        };

        orgService.getOrganizationActivity = function(params) {
            var config = {
                url: SERVICE_ROOT() + 'activity',
                method: httpMethods.POST,
                data: params
            };
            return $http(EndpointService.tokenize(config));
        };

        function updateOrganization(data) {
            var config = {
                url: SERVICE_ROOT(),
                method: httpMethods.PUT,
                data: data
            };

            return $http(EndpointService.tokenize(config));
        }

        orgService.setOrganizationLocale = function(local) {
            var data = {
                Locale: local
            };
            return updateOrganization(data);
        };

        orgService.setOrganizationStorageLimit = function(storageLimitInBytes, storageType) {
            var data = {
                StorageRule: {
                    StorageAllocatedInBytes: storageLimitInBytes,
                    StorageType: storageType
                }
            };
            return updateOrganization(data);
        };

        orgService.setContentRetentionTimeInSeconds = function(retentionTimeInSeconds) {
           var data = {
                ContentRetentionTimeInSeconds: retentionTimeInSeconds
           };

           return updateOrganization(data);
        };

        orgService.convertOrganization = function(organizationId) {
            var data = {
                Mode: "FEDERATED_IDENTITY",
                Id:organizationId
            };
            var config = {
                url: NEW_SERVICE_ROOT() + encodeURIComponent(organizationId) + '/conversion' ,
                method: httpMethods.PUT ,
                data: data
            };
            return $http(EndpointService.tokenize(config));
        };

        orgService.setOrganizationRules = function(sharingRule, userInviteRule, newUserRule, selfActivationRule, newOrgWideSharingScope) {            
            var data = {};
            if(sharingRule){
                data.SharingRule = sharingRule;
            }
            if(userInviteRule){
                data.UserInviteRule= userInviteRule;
            }
            if(newUserRule){
                $log.log("Updating NewUserRule. Looks like this was changed by user.");
                data.NewUserRule= newUserRule;
            }
            if(selfActivationRule !== undefined && selfActivationRule !== null){
                data.SelfActivationRule= selfActivationRule;
            }
            if(newOrgWideSharingScope){
                data.OrgWideSharingScope = newOrgWideSharingScope;
                AppConstants.ORG_WIDE_SHARING_SCOPE = data.OrgWideSharingScope;
            }
            
            return updateOrganization(data);
        };

        orgService.setOrganizationExternalInviteRule = function(externalUserInviteRule) {
            var data = {};
            data.ExternalUserInviteRule= externalUserInviteRule;
            return updateOrganization(data);
        };

        orgService.getOrganizationUsers = function(params) {
            var config = {
                url: SERVICE_ROOT() + 'user',
                method: httpMethods.GET,
                params: params
            };
            return $http(EndpointService.tokenize(config));
        };

        orgService.searchOrganizationUsers = function(params, cancelerPromise) {
            var config = {
                url: SERVICE_ROOT() + 'user/search',
                method: httpMethods.GET,
                params: params
            };

            if (cancelerPromise) {
                config.timeout = cancelerPromise;
            }

            return $http(EndpointService.tokenize(config));
        };

        orgService.searchUsers = function(query, params) {
            var
                defaultParams = {
                    excludeSelf: false,
                    includeInactiveUsers: false,
                    currentUsername: null,
                    reuseLastSearchOnError: true
                },
                deferred, queryComponents, searchQuery, filter;

            params = angular.extend({}, defaultParams, params);

            deferred = $q.defer();

            queryComponents = $.map(query.split(','), $.trim);
            searchQuery = queryComponents[queryComponents.length - 1];
            if (searchQuery.length === 0) {
                deferred.reject();
            }

            if (params.includeInactiveUsers) {
                filter = 'ALL';
            } else {
                filter = 'ACTIVE_PENDING';
            }

            orgService.searchOrganizationUsers({
                query: searchQuery,
                filter: filter
            }).then(function(response) {
                var data = response.data,
                    results = [];
                angular.forEach(data.Users, function(user) {
                    if ((!params.excludeSelf || (user.Id !== authenticatedUser.getUserInfo().Id)) && user.Username !== params.currentUsername) {
                        if (!user.GivenName) {
                            // Display the email if the user does not have a given name or the status is pending (it will only be pending for admins)
                            user.type = 'USER';
                            user.displayName = user.Username;
                            user.GivenName = user.Username;
                            user.Surname = '';
                            results.push(user);
                        } else {
                            // Display the user's name as a concatenation of given name surname and user name if the user is active'
                            user.type = 'USER';
                            user.displayName = user.GivenName + ' ' + user.Surname + ' (' + user.Username + ')';
                            results.push(user);
                        }
                    }
                });

                // Append the query to the results (to get around having to use ui-keydown for entries which don't have a typeahead match).
                // We use a customUser object to help differentiate between custom email entries and actual users returned from the service.
                if (results && results.length === 0) {
                    results.push({
                        type: collaboratorTypes.ANONYMOUS,
                        displayName: query,
                        GivenName: query,
                        Surname: '',
                        Username: query,
                    });
                }

                lastSearchOrgUsers = results;
                deferred.resolve(results);
            }, function() {
                if (!!lastSearchOrgUsers && params.reuseLastSearchOnError) {
                    deferred.resolve(lastSearchOrgUsers);
                } else {
                    deferred.reject([]);
                }
            });

            return deferred.promise;
        };

        return orgService;
    }
}(angular));
